import {useFetch} from "@vueuse/core"

type LogoutArgs = {to?: string}

export function useLogoutFunction(args: LogoutArgs = {}) {
  const logout = useFetch("/logout", {headers: {"Content-Type": "application/json"}}, {immediate: false}).post()
  logout.onFetchResponse(() => window.location.href = args.to ?? "/")
  return logout.execute
}

// Not a fan of the type name, but I don't want to just call it User.  UserInfo it is, I guess...
export type UserInfo = {
  id: number
  login: string
  email: string
  fullname: string
  nickname: string
  role: string
  impersonated: boolean
  isCleverUser: boolean
}
